export default __webpack_public_path__ + "static/img2-c42b273ba0504065a48a4cf6c3eaa60e.png";